import { render, staticRenderFns } from "./AddConsultantDocuments.vue?vue&type=template&id=6ac9be14&"
import script from "./AddConsultantDocuments.vue?vue&type=script&lang=ts&"
export * from "./AddConsultantDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports